import { TableHeader } from 'mbs-ui-kit';

export const subHeaders: TableHeader[] = [
  {
    name: '',
    class: '-stretch pl-0',
    gridColSize: '1fr'
  }
];
export const headers: TableHeader[] = [
  {
    name: '',
    class: '-stretch pl-0',
    gridColSize: '1fr',
    gridColMin: '150px'
  },
  {
    name: '',
    gridColSize: '250px',
    gridColMin: '250px',
    class: '-stretch text-end'
  }
];
